var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.useHeaderBar && _vm.showAvatar)?_c('div',{staticClass:"kai-avatar"},[_c('div',{staticClass:"lottie lottie-isdefault",attrs:{"aria-hidden":"true","data-bm-renderer":"svg"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }